import { mergeHead, type HeadDescriptor } from '../shared/seo/HeadDescriptor.js';
import { defaultHead } from '../shared/seo/defaultHead.js';
import { breadcrumbJsonLd, type SiteInfo } from '../shared/seo/jsonld.js';
import type { SeccionData, SeccionKind } from './models/entities/SeccionData.js';

/**
 * El `<head>` de `/ultima-hora` y `/mas-leidas`.
 *
 * El título y la bajada salen de la respuesta y no de una constante de acá: el rótulo lo pone la
 * redacción ("Última hora" puede ser "Lo último"), y si el `<title>` dijera otra cosa que el `<h1>`
 * el crawler vería dos nombres para la misma página.
 *
 * `page` entra en el canonical, igual que en una sección: la página 2 es una URL propia.
 */
export function headDeSeccion(
  kind: SeccionKind,
  data: Pick<SeccionData, 'titulo' | 'descripcion'>,
  site: SiteInfo,
  page = 1,
): HeadDescriptor {
  const base = `/${kind}`;
  const path = page > 1 ? `${base}?page=${page}` : base;

  return mergeHead(defaultHead(site, path), {
    title: `${data.titulo} — ${site.name}`,
    description: data.descripcion,
    jsonLd: [
      breadcrumbJsonLd([
        { name: 'Portada', url: `${site.url}/` },
        { name: data.titulo, url: `${site.url}${base}` },
      ]),
    ],
  });
}
